import { useMemo } from 'react';
import { isServiceColumn, SYMBOL_FOR_EMPTY_CELL } from '@/components/AgGrid/helpers';
import isEmpty from 'lodash/isEmpty';

const hiddenMenuItems = ['sortAscending', 'sortDescending', 'columnChooser', 'resetColumns', 'sortUnSort'];
const hiddenSeparatorBefore = ['pinSubMenu', 'columnChooser'];

const useAgGridProps = () => {
  return useMemo(
    () => ({
      rowHeight: 72,
      suppressContextMenu: true,
      animateRows: false,
      suppressMaxRenderedRowRestriction: true,
      suppressMoveWhenColumnDragging: true,
      suppressDragLeaveHidesColumns: true,
      tooltipShowMode: 'whenTruncated' as const,
      tooltipShowDelay: 0,
      scrollbarWidth: 8,
      alwaysShowHorizontalScroll: true,
      alwaysShowVerticalScroll: true,
      defaultColDef: {
        suppressHeaderMenuButton: true,
        filter: true,
        sortable: true,
        resizable: true,
        minWidth: 120,
        suppressNavigable: true,
        headerComponentParams: {
          enablePinning: true,
        },
        valueFormatter: ({ value, colDef }) => {
          if (isServiceColumn(colDef?.field)) return null;

          return isEmpty(value) ? SYMBOL_FOR_EMPTY_CELL : value;
        },
      },
      getMainMenuItems: (e) => {
        const { defaultItems = [] } = e;

        return Array.isArray(defaultItems)
          ? defaultItems.reduce((acc, item, index, arr) => {
              // Filter out some options and separators
              if (hiddenMenuItems.includes(item)) return acc;
              if (item === 'separator' && (hiddenSeparatorBefore.includes(arr[index + 1]) || !acc.length)) return acc;

              acc.push(item);
              return acc;
            }, [])
          : [];
      },
    }),
    [],
  );
};
export default useAgGridProps;
